import React from "react";
import Project from "./project.js";

class ProjectRow extends React.Component {
  /**
   * Returns a collection of projects, or a loading indicator if none exist yet.
   * @return {array.<ReactElement>}
   */
  createProjects() {
    return this.props.projects.map(function (project, index) {
      return (
        <Project
          key={`pkey${project.id}`}
          name={project.name}
          path={project.path}
          id={project.id}
          langSplits={project.lang_splits}
          desc={project.description}
          years={project.years}
          index={index}
          group={this.props.group}
          onMouseOver={project.onMouseOverProject}
          onMouseOut={project.onMouseOutProject}
          category={this.props.category}
        />
      );
    }, this);
  }

  /**
   */
  render() {
    return <div className="project-row">{this.createProjects()}</div>;
  }
}

export default ProjectRow;
